import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { SessionProvider } from './lib/session.js';
import { ToastProvider } from './components/ui.js';

const container = document.getElementById('root');

if (container) {
  createRoot(container).render(
    <StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <ToastProvider>
            <SessionProvider>
              <App />
            </SessionProvider>
          </ToastProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </StrictMode>,
  );
} else {
  // Nu aruncăm: un throw aici lasă pagina complet albă, fără nicio explicație pentru utilizator.
  document.body.innerHTML =
    '<div style="font-family:system-ui,sans-serif;padding:32px;max-width:520px;margin:0 auto">' +
    '<h1 style="font-size:20px">Pagina nu a putut fi încărcată</h1>' +
    '<p style="color:#4a5568">Elementul rădăcină al aplicației lipsește. Reîncarcă pagina.</p></div>';
}
